import i18n from "i18next"

export const generateRules = () => ({
    message: [{ required: true, message: i18n.t("validation:required"), trigger: "blur" }],
})
